import type { HTMLProps } from 'react';

import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

import type { ComponentProps } from '../ComponentProps';
import { getClassNameOverride } from '../getClassNameOverride';
import { State } from './types';

interface FieldMessageProps
  extends ComponentProps<HTMLProps<HTMLParagraphElement>> {
  state?: keyof typeof State;
}

const fieldMessage = variants({
  base: ['text-body-sm', 'text-default'],
  variants: {
    state: {
      default: ['text-default'],
      valid: ['text-success-default'],
      invalid: ['text-error-default'],
      disabled: ['text-disabled'],
      warning: ['text-warning-default'],
    },
  },
});

function FieldMessage({
  children,
  state = 'default',
  ...props
}: FieldMessageProps) {
  const className = getClassNameOverride(props);

  return (
    <p {...props} className={cn(fieldMessage({ state }), className)}>
      {children}
    </p>
  );
}

FieldMessage.displayName = 'FieldMessage';
FieldMessage.State = State;

export { FieldMessage };
